export default [
    {
        path: '/teacherLicense',
        name: 'teacherLicense',
        component: () => import ('./pages/teacherLicenseRegister')
    },
]